import { useSelector } from 'react-redux';
import { selectBuilder } from '../../selectors/builder';
import { useBuilderToBanksMap } from './hooks/useBuilderToBanksMap';
import { AccreditationBanks } from '../../components/AccreditationBanks';
import * as React from 'react';

export const AccreditationBanksContainer = () => {
  const buildersToBanksMap = useBuilderToBanksMap();
  const { id } = useSelector(selectBuilder);

  const banks = buildersToBanksMap[id];

  if (!banks?.length) {
    return null;
  }

  return <AccreditationBanks banks={banks} />;
};
